import Cookies from "universal-cookie";

const cookies = new Cookies();

export function setToken(token: string) {
  cookies.set("token", token, { path: "/", maxAge: 60 * 60 * 24 });
}

export function getToken() {
  return cookies.get("token");
}

export function clearToken() {
  cookies.remove("token", { path: "/" });
}

export function getRefreshToken() {
  return cookies.get("refresh_token");
}

export function setRefreshToken(refreshToken: string) {
  cookies.set("refresh_token", refreshToken, {
    path: "/",
    maxAge: 60 * 60 * 24,
  });
}

export function clearRefreshToken() {
  cookies.remove("refresh_token", { path: "/" });
}

export function clearAllTokens() {
  localStorage.removeItem("sso-user");
  clearToken();
  clearRefreshToken();
}
